import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7818c09a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-2 members-dropdown-content" }
const _hoisted_2 = { class: "members-dropdown-content__sticky" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "members-dropdown-content__sticky__members my-1" }, "Board members", -1))
const _hoisted_4 = { class: "members-dropdown-content__list p-0 m-0" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "m-0 flex-grow-1" }
const _hoisted_7 = {
  key: 0,
  class: "bi bi-check"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "form-control members-dropdown-content__input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        name: "members",
        placeholder: "Search members"
      }, null, 512), [
        [_vModelText, _ctx.search]
      ]),
      _hoisted_3
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedBoardMembers, (mem) => {
        return (_openBlock(), _createElementBlock("li", {
          key: mem._id,
          onClick: ($event: any) => (_ctx.handleMemberClick(mem)),
          class: "members-dropdown-content__list__item d-flex gap-2 p-1 rounded-1 align-items-center justify-content-start"
        }, [
          _createVNode(_component_avatar, {
            name: mem.name
          }, null, 8, ["name"]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(mem.name) + "(" + _toDisplayString(_ctx.sliceMail(mem.email)) + ")", 1),
          (_ctx.isTaskMember(mem._id))
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : _createCommentVNode("", true)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}